import { c as _c } from "react/compiler-runtime";
import { Fragment } from 'react';
import { useViewport } from '@sbt-web/hooks';
import type { AdItem } from '@sbt-web/network/types';
import { PhoneButton } from '../../../AdReply/components/AdReplyButtons/PhoneButton';
import { PHONE_NUMBER_PLACEHOLDER, MOBILE_LABEL, DESKTOP_LABEL } from './config';
import classes from './index.module.scss';
interface ReplacePhoneNumberWithButtonProps {
  ad: AdItem;
}
export const ReplacePhoneNumberWithButton = t0 => {
  const $ = _c(5);
  const {
    ad
  } = t0;
  const {
    isMobile
  } = useViewport();
  let t1;
  if ($[0] !== ad || $[1] !== isMobile) {
    const parts = ad.body.split(PHONE_NUMBER_PLACEHOLDER);
    let t2;
    if ($[3] !== ad.urn) {
      t2 = (part, index) => ({
        content: part,
        key: `${ad.urn}-${index}`
      });
      $[3] = ad.urn;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    const partsWithKeys = parts.map(t2);
    t1 = partsWithKeys.map((part_0, index_0) => <Fragment key={part_0.key}>{part_0.content}{index_0 < parts.length - 1 && <PhoneButton isMobile={isMobile} adUrn={ad.urn} item={ad} buttonDesign="text" buttonSize="medium" buttonLabelDesktop={DESKTOP_LABEL} buttonLabelMobile={MOBILE_LABEL} buttonClass={classes["show-number"]} pulseEvent={{
        name: "Ad Description",
        pageType: "ad_detail"
      }} />}</Fragment>);
    $[0] = ad;
    $[1] = isMobile;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};